const CONTENT_HUBS = {
  'en-US': [
    {
      id: 'activities',
      label: 'Outdoor activity guides',
      description: 'Learn formats, seasonality, and what kind of experience fits you.',
      path: '/outdoor-activities',
    },
    {
      id: 'destinations',
      label: 'Outdoor destinations',
      description: 'Explore regions, mountain towns, and where to go next.',
      path: '/outdoor-destinations',
    },
    {
      id: 'stories',
      label: 'Outdoor stories',
      description: 'Stay on Crion for inspiration, practical ideas, and curated articles.',
      path: '/outdoor-stories',
    },
  ],
  'it-IT': [
    {
      id: 'activities',
      label: 'Guide alle attività outdoor',
      description: 'Scopri formati, stagionalità e quale esperienza fa per te.',
      path: '/attivita-outdoor',
    },
    {
      id: 'destinations',
      label: 'Destinazioni outdoor',
      description: 'Esplora regioni, località di montagna e idee per il prossimo viaggio.',
      path: '/destinazioni-outdoor',
    },
    {
      id: 'stories',
      label: 'Storie outdoor',
      description: 'Resta su Crion per ispirazione, idee pratiche e articoli utili.',
      path: '/storie-outdoor',
    },
  ],
  'fr-FR': [
    {
      id: 'activities',
      label: 'Guides activités outdoor',
      description: 'Comprenez les formats, la saisonnalité et l\'expérience qui vous convient.',
      path: '/activites-outdoor',
    },
    {
      id: 'destinations',
      label: 'Destinations outdoor',
      description: 'Explorez des régions, des villages de montagne et de nouvelles idées.',
      path: '/destinations-outdoor',
    },
    {
      id: 'stories',
      label: 'Histoires outdoor',
      description: 'Restez sur Crion pour l\'inspiration, des idées concrètes et des articles.',
      path: '/histoires-outdoor',
    },
  ],
  'de-DE': [
    {
      id: 'activities',
      label: 'Outdoor-Aktivitäten Guides',
      description: 'Verstehen Sie Formate, Saisonalität und passende Erlebnisse.',
      path: '/outdoor-aktivitaeten',
    },
    {
      id: 'destinations',
      label: 'Outdoor-Ziele',
      description: 'Entdecken Sie Regionen, Bergorte und neue Reiseideen.',
      path: '/outdoor-ziele',
    },
    {
      id: 'stories',
      label: 'Outdoor-Geschichten',
      description: 'Bleiben Sie auf Crion für Inspiration, praktische Ideen und Artikel.',
      path: '/outdoor-geschichten',
    },
  ],
};

const AI_COPY = {
  'en-US': {
    navLabel: 'Crion AI',
    sectionEyebrow: 'Crion AI trip planning',
    sectionTitle: 'Ask, learn, and find the right outdoor plan in one place.',
    sectionDescription:
      'Crion AI helps users discover outdoor ideas, understand what fits their level, and jump into matching Crion listings with direct links, filters, and session clues.',
    sectionPrimaryCta: 'Open full AI planner',
    sectionSecondaryCta: 'Try it in chat',
    sectionPanelTitle: 'What Crion AI can do today',
    sectionPanelItems: [
      'Turn vague ideas into relevant listings on Crion.',
      'Explain group vs private, level, duration, and practical fit.',
      'Keep users exploring with content hubs, not just one search result.',
    ],
    sectionExpectationsTitle: 'What users should expect',
    sectionExpectations: [
      'A short answer in normal language',
      'Crion listings with links when available',
      'Filters and next steps when the match is not exact',
    ],
    pageTitle: 'Crion AI | Outdoor trip planner and discovery assistant',
    pageDescription:
      'Use Crion AI to discover outdoor activities, compare options, learn what fits your plan, and jump straight into bookable Crion listings.',
    pageEyebrow: 'Crion AI',
    pageTitleText: 'Set preferences. Get a shortlist. Refine in chat.',
    pageIntro:
      'Choose your activity, level, location, dates, and budget — Crion AI instantly builds a matched shortlist of bookable experiences and opens the chat so you can go deeper. Free to use with no account needed. Register to save your plan and get unlimited suggestions every time you plan a new adventure.',
    pagePrimaryCta: 'Build your free plan',
    pageSecondaryCta: 'Browse Crion content hubs',
    capabilityTitle: 'How it works',
    capabilityCards: [
      {
        id: 'preferences',
        title: 'Set preferences',
        description: 'Use the planner below to pick activity, level, location, dates, and budget in a few clicks.',
      },
      {
        id: 'shortlist',
        title: 'Get matched listings',
        description: 'Crion AI reads your inputs and surfaces bookable experiences with direct links the moment you submit.',
      },
      {
        id: 'refine',
        title: 'Refine in chat',
        description: 'Ask follow-up questions, compare options, adjust any detail, and open listings — all in one conversation.',
      },
    ],
    widgetWelcomeEyebrow: 'Plan faster with Crion AI',
    widgetWelcomeTitle: 'Your first shortlist is ready — keep chatting to go deeper.',
    widgetWelcomeDescription:
      'Crion AI matched your preferences to bookable experiences. Use the chat to compare formats, ask practical questions, or adjust any detail.',
    widgetWelcomePoints: [
      'Explore freely — no sign-up needed to chat',
      'Register to save your plan and unlock unlimited suggestions',
      'Update preferences any time to refresh the shortlist',
    ],
    promptSectionTitle: 'Try these example prompts',
    resultsTitle: 'Listings suggested by Crion AI',
    resultItems: [
      'A destination or region',
      'Activity type or difficulty',
      'Dates, season, or group preferences',
    ],
    hubTitle: 'Keep exploring on Crion',
    hubCtaLabel: 'Open on Crion',
    bottomCtaTitle: 'Prefer to browse everything manually?',
    bottomCtaText:
      'Open the full Crion marketplace to scan all listings, or keep using the chat and refine destination, level, dates, or group size to narrow the shortlist.',
    homeLinkLabel: 'Check all listings',
    examples: [
      {
        id: 'weekend-hike',
        label: 'Weekend hike',
        prompt:
          'Find me a beginner-friendly hike near Zurich next weekend with small groups and upcoming sessions.',
        expectation: 'Expect curated Crion options, filters, and a fast path to listings.',
      },
      {
        id: 'private-climb',
        label: 'Private climbing',
        prompt: 'Show me private climbing experiences for 2 people in Chamonix with flexible dates.',
        expectation: 'Good for learning whether private or group format fits your plan.',
      },
      {
        id: 'snow-march',
        label: 'March snow plan',
        prompt: 'What are good snow adventures on Crion in March for intermediate level travelers?',
        expectation: 'Useful for seasonal inspiration plus listing discovery.',
      },
      {
        id: 'alp-escape',
        label: '3-day Alps escape',
        prompt:
          'I want a 3-day outdoor escape in the Alps. Give me ideas and then show the most relevant Crion listings.',
        expectation: 'Best for mixed inspiration plus conversion-oriented answers.',
      },
      {
        id: 'via-ferrata-first-time',
        label: 'First via ferrata',
        prompt:
          'What gear do I need for a first via ferrata, and can you show beginner-friendly guided options on Crion?',
        expectation: 'Useful for combining practical advice with the right listing type.',
      },
      {
        id: 'family-june',
        label: 'Family June weekend',
        prompt:
          'Plan a family-friendly outdoor weekend in the Dolomites in June with easy activities and kid-suitable options.',
        expectation: 'Good for family planning, seasonality, and easy listing discovery.',
      },
      {
        id: 'mtb-no-car',
        label: 'MTB without car',
        prompt:
          'Where can I do beginner MTB from Milan without renting a car, and what Crion experiences fit that plan?',
        expectation: 'Tests destination, logistics, and listing recommendations together.',
      },
      {
        id: 'snowboard-compare',
        label: 'Private vs group',
        prompt: 'Is a private snowboard lesson better than a group lesson for a first timer on a weekend trip?',
        expectation: 'Good for comparison-style answers that gradually lead to the right format.',
      },
      {
        id: 'mixed-weather',
        label: 'Mixed weather backup',
        prompt:
          'I will be near Interlaken this Saturday. What outdoor experiences still work well if the weather is mixed?',
        expectation: 'Useful for weather-aware planning and fallback listing discovery.',
      },
      {
        id: 'lake-como-trail',
        label: 'Trail near Como',
        prompt: 'Show me trail running or fast hiking experiences for intermediate level near Lake Como.',
        expectation: 'Good for users who already know the region and want fast shortlist options.',
      },
      {
        id: 'team-day',
        label: 'Team day outdoors',
        prompt:
          'I need an outdoor team activity for 8 colleagues near Geneva. What would fit best and what can I book on Crion?',
        expectation: 'Tests small-group booking intent with planning support.',
      },
    ],
  },
  'it-IT': {
    navLabel: 'Crion AI',
    sectionEyebrow: 'Crion AI per pianificare outdoor',
    sectionTitle: 'Chiedi, impara e trova il piano outdoor giusto in un solo posto.',
    sectionDescription:
      'Crion AI aiuta a scoprire idee outdoor, capire cosa è adatto al proprio livello e passare subito a listing Crion con link, filtri e dettagli utili sulle sessioni.',
    sectionPrimaryCta: 'Apri il planner AI completo',
    sectionSecondaryCta: 'Provalo in chat',
    sectionPanelTitle: 'Cosa può fare oggi Crion AI',
    sectionPanelItems: [
      'Trasformare idee vaghe in listing rilevanti su Crion.',
      'Spiegare privato vs gruppo, livello, durata e fit pratico.',
      'Tenere l\'utente su Crion con hub editoriali e ispirazione.',
    ],
    sectionExpectationsTitle: 'Cosa aspettarsi',
    sectionExpectations: [
      'Una risposta breve e chiara',
      'Listing Crion con link quando disponibili',
      'Filtri e alternative anche senza match perfetto',
    ],
    pageTitle: 'Crion AI | Assistente per pianificare esperienze outdoor',
    pageDescription:
      'Usa Crion AI per scoprire attività outdoor, confrontare opzioni, capire cosa fa per te e passare subito ai listing Crion.',
    pageEyebrow: 'Crion AI',
    pageTitleText: 'Imposta le preferenze. Ottieni una shortlist. Raffina in chat.',
    pageIntro:
      'Scegli attività, livello, luogo, date e budget — Crion AI costruisce subito una shortlist di esperienze prenotabili e apre la chat per approfondire. Gratuito, senza registrazione. Registrati per salvare il piano e ricevere suggerimenti illimitati ogni volta che pianifichi una nuova avventura.',
    pagePrimaryCta: 'Crea il tuo piano gratis',
    pageSecondaryCta: 'Esplora gli hub editoriali Crion',
    capabilityTitle: 'Come funziona',
    capabilityCards: [
      {
        id: 'preferences',
        title: 'Imposta le preferenze',
        description: 'Usa il planner qui sotto per scegliere attività, livello, luogo, date e budget in pochi click.',
      },
      {
        id: 'shortlist',
        title: 'Ottieni i listing',
        description: 'Crion AI legge le tue scelte e mostra subito esperienze prenotabili con link diretti.',
      },
      {
        id: 'refine',
        title: 'Raffina in chat',
        description: "Fai domande, confronta opzioni, modifica i dettagli e apri i listing — tutto in un'unica conversazione.",
      },
    ],
    widgetWelcomeEyebrow: 'Pianifica più velocemente con Crion AI',
    widgetWelcomeTitle: 'La tua prima shortlist è pronta — continua a chattare per approfondire.',
    widgetWelcomeDescription:
      'Crion AI ha abbinato le tue preferenze a esperienze prenotabili. Usa la chat per confrontare formati, fare domande pratiche o modificare qualsiasi dettaglio.',
    widgetWelcomePoints: [
      'Esplora liberamente — nessuna registrazione richiesta per la chat',
      'Registrati per salvare il piano e sbloccare suggerimenti illimitati',
      'Aggiorna le preferenze in qualsiasi momento per aggiornare la shortlist',
    ],
    promptSectionTitle: 'Prova questi prompt',
    resultsTitle: 'Listing suggeriti da Crion AI',
    resultItems: [
      'Una destinazione o una regione',
      'Tipo di attività o difficoltà',
      'Date, stagione o preferenze di gruppo',
    ],
    hubTitle: 'Continua a esplorare su Crion',
    hubCtaLabel: 'Apri su Crion',
    bottomCtaTitle: 'Preferisci esplorare tutto manualmente?',
    bottomCtaText:
      'Apri il marketplace completo di Crion per vedere tutti i listing, oppure continua in chat e affina destinazione, livello, date o gruppo per ottenere una shortlist più precisa.',
    homeLinkLabel: 'Vedi tutti i listing',
    examples: [
      {
        id: 'weekend-hike',
        label: 'Escursione weekend',
        prompt:
          'Trova per me una camminata facile vicino a Zurigo il prossimo weekend con piccoli gruppi e sessioni disponibili.',
        expectation: 'Ottimo per vedere opzioni Crion, filtri e passaggio rapido ai listing.',
      },
      {
        id: 'private-climb',
        label: 'Arrampicata privata',
        prompt: 'Mostrami esperienze di arrampicata privata per 2 persone a Chamonix con date flessibili.',
        expectation: 'Utile per capire se privato o gruppo è il formato giusto per il viaggio.',
      },
      {
        id: 'snow-march',
        label: 'Neve a marzo',
        prompt: 'Quali sono buone avventure sulla neve su Crion a marzo per viaggiatori di livello intermedio?',
        expectation: 'Buono per ispirazione stagionale e scoperta di listing.',
      },
      {
        id: 'alp-escape',
        label: '3 giorni sulle Alpi',
        prompt:
          'Voglio un escape outdoor di 3 giorni sulle Alpi. Dammi idee e poi mostrami i listing Crion più rilevanti.',
        expectation: 'Ideale per unire ispirazione e conversione.',
      },
      {
        id: 'via-ferrata-first-time',
        label: 'Prima via ferrata',
        prompt:
          'Che attrezzatura mi serve per una prima via ferrata, e puoi mostrarmi anche opzioni guidate facili su Crion?',
        expectation: 'Unisce consiglio pratico e tipo di esperienza giusta.',
      },
      {
        id: 'family-june',
        label: 'Weekend famiglia a giugno',
        prompt:
          'Organizza un weekend outdoor family-friendly sulle Dolomiti a giugno con attività facili e adatte ai bambini.',
        expectation: 'Buono per famiglie, stagionalità e scouting di listing semplici.',
      },
      {
        id: 'mtb-no-car',
        label: 'MTB senza auto',
        prompt:
          'Dove posso fare MTB facile partendo da Milano senza noleggiare un\'auto, e quali esperienze Crion si adattano?',
        expectation: 'Testa insieme destinazione, logistica e suggerimenti di listing.',
      },
      {
        id: 'snowboard-compare',
        label: 'Privato o gruppo',
        prompt:
          'Per un principiante in un weekend, è meglio una lezione privata di snowboard o una lezione di gruppo?',
        expectation: 'Ottimo per risposte comparative che portano al formato giusto.',
      },
      {
        id: 'mixed-weather',
        label: 'Piano con meteo incerto',
        prompt:
          'Sarò vicino a Interlaken questo sabato. Quali esperienze outdoor funzionano bene anche con meteo variabile?',
        expectation: 'Utile per pianificazione con meteo e alternative concrete.',
      },
      {
        id: 'lake-como-trail',
        label: 'Trail vicino Como',
        prompt: 'Mostrami esperienze di trail running o fast hiking di livello intermedio vicino al Lago di Como.',
        expectation: 'Buono per chi conosce già la zona e vuole una shortlist veloce.',
      },
      {
        id: 'team-day',
        label: 'Team day outdoor',
        prompt:
          'Mi serve un\'attività outdoor per 8 colleghi vicino a Ginevra. Cosa può funzionare meglio e cosa posso prenotare su Crion?',
        expectation: 'Testa intento di booking per piccoli gruppi con supporto decisionale.',
      },
    ],
  },
  'fr-FR': {
    navLabel: 'Crion AI',
    sectionEyebrow: 'Crion AI pour planifier outdoor',
    sectionTitle: 'Demandez, apprenez et trouvez le bon plan outdoor au même endroit.',
    sectionDescription:
      'Crion AI aide à découvrir des idées outdoor, comprendre ce qui correspond au niveau de chacun et passer directement vers des listings Crion avec liens, filtres et détails utiles.',
    sectionPrimaryCta: 'Ouvrir le planner AI complet',
    sectionSecondaryCta: 'Tester dans le chat',
    sectionPanelTitle: 'Ce que Crion AI peut faire maintenant',
    sectionPanelItems: [
      'Transformer une idée vague en listings pertinents sur Crion.',
      'Expliquer privé vs groupe, niveau, durée et adéquation pratique.',
      'Garder l\'utilisateur sur Crion avec inspiration et contenu utile.',
    ],
    sectionExpectationsTitle: 'À quoi s\'attendre',
    sectionExpectations: [
      'Une réponse courte et claire',
      'Des listings Crion avec liens quand ils existent',
      'Des filtres et alternatives si le match n\'est pas exact',
    ],
    pageTitle: 'Crion AI | Assistant pour planifier des expériences outdoor',
    pageDescription:
      'Utilisez Crion AI pour découvrir des activités outdoor, comparer des options, comprendre ce qui vous convient et passer aux listings Crion.',
    pageEyebrow: 'Crion AI',
    pageTitleText: 'Définissez vos préférences. Obtenez une shortlist. Affinez en chat.',
    pageIntro:
      "Choisissez votre activité, niveau, lieu, dates et budget — Crion AI construit instantanément une shortlist d'expériences réservables et ouvre le chat pour aller plus loin. Gratuit, sans inscription. Inscrivez-vous pour sauvegarder votre plan et obtenir des suggestions illimitées pour chaque aventure.",
    pagePrimaryCta: 'Créer votre plan gratuit',
    pageSecondaryCta: 'Explorer les hubs éditoriaux Crion',
    capabilityTitle: 'Comment ça marche',
    capabilityCards: [
      {
        id: 'preferences',
        title: 'Définissez vos préférences',
        description: 'Utilisez le planificateur ci-dessous pour choisir activité, niveau, lieu, dates et budget en quelques clics.',
      },
      {
        id: 'shortlist',
        title: 'Obtenez vos listings',
        description: "Crion AI lit vos choix et affiche immédiatement des expériences réservables avec des liens directs.",
      },
      {
        id: 'refine',
        title: 'Affinez en chat',
        description: "Posez des questions, comparez les options, ajustez les détails et accédez aux listings — tout en une seule conversation.",
      },
    ],
    widgetWelcomeEyebrow: 'Planifiez plus vite avec Crion AI',
    widgetWelcomeTitle: 'Votre première shortlist est prête — continuez à chatter pour aller plus loin.',
    widgetWelcomeDescription:
      "Crion AI a associé vos préférences à des expériences réservables. Utilisez le chat pour comparer les formats, poser des questions pratiques ou ajuster n'importe quel détail.",
    widgetWelcomePoints: [
      'Explorez librement — aucune inscription requise pour chatter',
      'Inscrivez-vous pour sauvegarder votre plan et débloquer des suggestions illimitées',
      'Mettez à jour vos préférences à tout moment pour rafraîchir la shortlist',
    ],
    promptSectionTitle: 'Essayez ces prompts',
    resultsTitle: 'Listings suggérés par Crion AI',
    resultItems: [
      'Une destination ou une région',
      'Un type d\'activité ou une difficulté',
      'Des dates, une saison ou des préférences de groupe',
    ],
    hubTitle: 'Continuez à explorer sur Crion',
    hubCtaLabel: 'Ouvrir sur Crion',
    bottomCtaTitle: 'Vous préférez tout parcourir manuellement ?',
    bottomCtaText:
      'Ouvrez la marketplace complète de Crion pour parcourir tous les listings, ou continuez dans le chat et affinez destination, niveau, dates ou taille du groupe pour obtenir une shortlist plus précise.',
    homeLinkLabel: 'Voir tous les listings',
    examples: [
      {
        id: 'weekend-hike',
        label: 'Randonnée weekend',
        prompt:
          'Trouve-moi une randonnée facile près de Zurich le week-end prochain avec petits groupes et sessions disponibles.',
        expectation: 'Bon pour voir des options Crion, filtres et liens directs.',
      },
      {
        id: 'private-climb',
        label: 'Escalade privée',
        prompt: 'Montre-moi des expériences d\'escalade privée pour 2 personnes à Chamonix avec dates flexibles.',
        expectation: 'Utile pour comparer format privé et groupe.',
      },
      {
        id: 'snow-march',
        label: 'Neige en mars',
        prompt: 'Quelles sont de bonnes aventures neige sur Crion en mars pour un niveau intermédiaire ?',
        expectation: 'Utile pour l\'inspiration saisonnière et les listings.',
      },
      {
        id: 'alp-escape',
        label: '3 jours dans les Alpes',
        prompt:
          'Je veux un séjour outdoor de 3 jours dans les Alpes. Donne-moi des idées puis montre les listings Crion les plus pertinents.',
        expectation: 'Le meilleur mix entre inspiration et passage au booking.',
      },
      {
        id: 'via-ferrata-first-time',
        label: 'Première via ferrata',
        prompt:
          'De quel équipement ai-je besoin pour une première via ferrata, et peux-tu aussi montrer des options guidées faciles sur Crion ?',
        expectation: 'Combine conseil pratique et bon type de listing.',
      },
      {
        id: 'family-june',
        label: 'Weekend famille en juin',
        prompt:
          'Planifie un weekend outdoor familial dans les Dolomites en juin avec des activités faciles et adaptées aux enfants.',
        expectation: 'Utile pour la famille, la saison et les listings simples.',
      },
      {
        id: 'mtb-no-car',
        label: 'MTB sans voiture',
        prompt:
          'Où puis-je faire du VTT débutant depuis Milan sans louer de voiture, et quelles expériences Crion correspondent ?',
        expectation: 'Teste destination, logistique et recommandations de listings.',
      },
      {
        id: 'snowboard-compare',
        label: 'Privé ou groupe',
        prompt:
          'Pour un débutant sur un weekend, vaut-il mieux un cours privé de snowboard ou un cours en groupe ?',
        expectation: 'Bon pour des réponses comparatives qui orientent vers le bon format.',
      },
      {
        id: 'mixed-weather',
        label: 'Météo changeante',
        prompt:
          'Je serai près d\'Interlaken samedi. Quelles expériences outdoor fonctionnent bien même si la météo est changeante ?',
        expectation: 'Utile pour la planification météo et des alternatives concrètes.',
      },
      {
        id: 'lake-como-trail',
        label: 'Trail près de Côme',
        prompt:
          'Montre-moi des expériences de trail running ou fast hiking de niveau intermédiaire près du lac de Côme.',
        expectation: 'Bon pour les utilisateurs qui connaissent déjà la région et veulent une shortlist rapide.',
      },
      {
        id: 'team-day',
        label: 'Journée team outdoor',
        prompt:
          'J\'ai besoin d\'une activité outdoor pour 8 collègues près de Genève. Qu\'est-ce qui conviendrait le mieux et que puis-je réserver sur Crion ?',
        expectation: 'Teste une intention de booking petit groupe avec aide à la décision.',
      },
    ],
  },
  'de-DE': {
    navLabel: 'Crion AI',
    sectionEyebrow: 'Crion AI für Outdoor-Planung',
    sectionTitle: 'Fragen, lernen und den richtigen Outdoor-Plan an einem Ort finden.',
    sectionDescription:
      'Crion AI hilft dabei, Outdoor-Ideen zu entdecken, den passenden Schwierigkeitsgrad zu verstehen und direkt in relevante Crion-Listings mit Links, Filtern und Session-Hinweisen zu wechseln.',
    sectionPrimaryCta: 'Vollständigen AI-Planer öffnen',
    sectionSecondaryCta: 'Im Chat testen',
    sectionPanelTitle: 'Was Crion AI heute kann',
    sectionPanelItems: [
      'Vage Ideen in relevante Crion-Listings verwandeln.',
      'Privat vs Gruppe, Niveau, Dauer und praktischen Fit erklären.',
      'Nutzer mit Content und Inspiration auf Crion halten.',
    ],
    sectionExpectationsTitle: 'Was Nutzer erwarten sollten',
    sectionExpectations: [
      'Eine kurze, klare Antwort',
      'Crion-Listings mit Links wenn vorhanden',
      'Filter und Alternativen auch ohne exakten Treffer',
    ],
    pageTitle: 'Crion AI | Assistent für Outdoor-Planung und Entdeckung',
    pageDescription:
      'Nutzen Sie Crion AI, um Outdoor-Aktivitäten zu entdecken, Optionen zu vergleichen und direkt zu passenden Crion-Listings zu springen.',
    pageEyebrow: 'Crion AI',
    pageTitleText: 'Präferenzen setzen. Shortlist erhalten. Im Chat verfeinern.',
    pageIntro:
      'Wählen Sie Aktivität, Niveau, Ort, Daten und Budget — Crion AI erstellt sofort eine passende Shortlist buchbarer Erlebnisse und öffnet den Chat für vertiefte Fragen. Kostenlos nutzbar, kein Account nötig. Registrieren, um Pläne zu speichern und unbegrenzte Vorschläge für jedes Abenteuer zu erhalten.',
    pagePrimaryCta: 'Kostenlosen Plan erstellen',
    pageSecondaryCta: 'Crion Content-Hubs entdecken',
    capabilityTitle: 'So funktioniert es',
    capabilityCards: [
      {
        id: 'preferences',
        title: 'Präferenzen setzen',
        description: 'Mit dem Planner unten Aktivität, Niveau, Ort, Daten und Budget in wenigen Klicks auswählen.',
      },
      {
        id: 'shortlist',
        title: 'Listings erhalten',
        description: 'Crion AI liest die Eingaben und zeigt sofort buchbare Erlebnisse mit direkten Links.',
      },
      {
        id: 'refine',
        title: 'Im Chat verfeinern',
        description: 'Fragen stellen, Optionen vergleichen, Details anpassen und Listings öffnen — alles in einer Unterhaltung.',
      },
    ],
    widgetWelcomeEyebrow: 'Schneller planen mit Crion AI',
    widgetWelcomeTitle: 'Ihre erste Shortlist ist bereit — chatten Sie weiter für mehr Tiefe.',
    widgetWelcomeDescription:
      'Crion AI hat Ihre Präferenzen mit buchbaren Erlebnissen abgeglichen. Nutzen Sie den Chat zum Vergleichen, für praktische Fragen oder um Details anzupassen.',
    widgetWelcomePoints: [
      'Frei erkunden — keine Registrierung nötig zum Chatten',
      'Registrieren für gespeicherte Pläne und unbegrenzte Vorschläge',
      'Präferenzen jederzeit aktualisieren, um die Shortlist zu aktualisieren',
    ],
    promptSectionTitle: 'Diese Prompts ausprobieren',
    resultsTitle: 'Von Crion AI vorgeschlagene Listings',
    resultItems: [
      'Einem Ziel oder einer Region',
      'Einer Aktivität oder Schwierigkeit',
      'Daten, Saison oder Gruppenwünschen',
    ],
    hubTitle: 'Weiter auf Crion entdecken',
    hubCtaLabel: 'Auf Crion öffnen',
    bottomCtaTitle: 'Möchten Sie lieber alles manuell durchsuchen?',
    bottomCtaText:
      'Öffnen Sie den kompletten Crion Marketplace, um alle Listings zu sehen, oder nutzen Sie den Chat weiter und verfeinern Sie Ziel, Niveau, Daten oder Gruppengröße für eine präzisere Auswahl.',
    homeLinkLabel: 'Alle Listings ansehen',
    examples: [
      {
        id: 'weekend-hike',
        label: 'Wochenendwanderung',
        prompt:
          'Finde eine einfache Wanderung bei Zürich für nächstes Wochenende mit kleinen Gruppen und verfügbaren Sessions.',
        expectation: 'Gut für schnelle Crion-Optionen, Filter und direkte Links.',
      },
      {
        id: 'private-climb',
        label: 'Private Klettertour',
        prompt: 'Zeig mir private Klettererlebnisse für 2 Personen in Chamonix mit flexiblen Daten.',
        expectation: 'Hilft beim Vergleich von Privat- und Gruppenformat.',
      },
      {
        id: 'snow-march',
        label: 'Schnee im März',
        prompt: 'Welche guten Schnee-Abenteuer gibt es auf Crion im März für Fortgeschrittene?',
        expectation: 'Gut für saisonale Inspiration plus Listing-Entdeckung.',
      },
      {
        id: 'alp-escape',
        label: '3 Tage Alpen',
        prompt:
          'Ich will einen 3-tägigen Outdoor-Trip in den Alpen. Gib mir Ideen und zeig dann die relevantesten Crion-Listings.',
        expectation: 'Starker Mix aus Inspiration und Conversion.',
      },
      {
        id: 'via-ferrata-first-time',
        label: 'Erste Via Ferrata',
        prompt:
          'Welche Ausrüstung brauche ich für eine erste Via Ferrata, und kannst du auch einfache geführte Optionen auf Crion zeigen?',
        expectation: 'Verbindet praktische Hilfe mit dem passenden Listing-Typ.',
      },
      {
        id: 'family-june',
        label: 'Familienwochenende Juni',
        prompt:
          'Plane ein familienfreundliches Outdoor-Wochenende in den Dolomiten im Juni mit leichten Aktivitäten und kinderfreundlichen Optionen.',
        expectation: 'Gut für Familienplanung, Saison und einfache Listings.',
      },
      {
        id: 'mtb-no-car',
        label: 'MTB ohne Auto',
        prompt:
          'Wo kann ich als Anfänger MTB ab Mailand ohne Mietwagen machen, und welche Crion-Erlebnisse passen dazu?',
        expectation: 'Testet Ziel, Logistik und passende Listing-Empfehlungen zusammen.',
      },
      {
        id: 'snowboard-compare',
        label: 'Privat oder Gruppe',
        prompt:
          'Ist für einen Anfänger auf einem Wochenendtrip ein privater Snowboardkurs besser als ein Gruppenkurs?',
        expectation: 'Gut für Vergleichsfragen, die langsam zum richtigen Format führen.',
      },
      {
        id: 'mixed-weather',
        label: 'Plan bei Mischwetter',
        prompt:
          'Ich bin diesen Samstag bei Interlaken. Welche Outdoor-Erlebnisse funktionieren auch gut bei wechselhaftem Wetter?',
        expectation: 'Hilft bei wetterbewusster Planung und konkreten Alternativen.',
      },
      {
        id: 'lake-como-trail',
        label: 'Trail am Comer See',
        prompt:
          'Zeig mir Trailrunning- oder Fast-Hiking-Erlebnisse für Fortgeschrittene in der Nähe des Comer Sees.',
        expectation: 'Gut für Nutzer, die die Region schon kennen und schnell eine Shortlist wollen.',
      },
      {
        id: 'team-day',
        label: 'Outdoor Teamtag',
        prompt:
          'Ich brauche eine Outdoor-Aktivität für 8 Kollegen bei Genf. Was passt am besten und was kann ich auf Crion buchen?',
        expectation: 'Testet Small-Group-Booking mit Entscheidungshilfe.',
      },
    ],
  },
};

export const normalizeCrionAILocale = locale =>
  (locale && AI_COPY[locale] ? locale : 'en-US');

export const getCrionAICopy = locale => {
  const normalizedLocale = normalizeCrionAILocale(locale);

  return {
    ...AI_COPY[normalizedLocale],
    hubs: CONTENT_HUBS[normalizedLocale],
  };
};

export const buildCrionAIPath = locale => `/${normalizeCrionAILocale(locale)}/crion-ai`;

export const buildLocalizedContentHubPath = (locale, path) =>
  `/${normalizeCrionAILocale(locale)}${path}`;

export const pickRandomCrionAIPrompts = (examples, count = 4) => {
  if (!Array.isArray(examples) || !examples.length) {
    return [];
  }

  const shuffled = [...examples];

  for (let index = shuffled.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(Math.random() * (index + 1));
    [shuffled[index], shuffled[swapIndex]] = [shuffled[swapIndex], shuffled[index]];
  }

  return shuffled.slice(0, Math.max(1, Math.min(count, shuffled.length)));
};

